import { Mark } from '@tiptap/core';

export const Subscript = Mark.create({
  name: 'subscript',

  parseHTML() {
    return [
      {
        tag: 'sub',
      },
      {
        style: 'vertical-align',
        getAttrs: (value: string | HTMLElement) => value === 'sub' && null,
      },
    ];
  },

  renderHTML() {
    return ['sub', 0];
  },

  addCommands() {
    return {
      toggleSubscript:
        () =>
        ({ commands }: any) => {
          commands.unsetMark('superscript');
          return commands.toggleMark(this.name);
        },
    };
  },
});
